import React from 'react';
import IconFilterMailSquare from '@/assets/icons/icon-filter-mail-square.svg?react';

interface FormGateProps {
  onAddFormClick?: () => void;
}

const PlusIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
  >
    <path d="M6.5 1v11M1 6.5h11" />
  </svg>
);

export const FormGate: React.FC<FormGateProps> = ({ onAddFormClick }) => {
  return (
    <div className="flex flex-col items-center px-3 py-9 text-center">
      <div className="mb-3.5 flex h-[50px] w-[50px] items-center justify-center rounded-[14px] bg-indigo-100">
        <IconFilterMailSquare className="h-6 w-6 text-indigo-600" />
      </div>
      <p className="mb-2 text-sm font-semibold text-neutral-900">Add a form first</p>
      <p className="mb-4 text-xs leading-relaxed text-neutral-500">
        Add a form element to your page first, then come back here to connect your integrations and
        send leads where they need to go.
      </p>
      {onAddFormClick && (
        <button
          onClick={onAddFormClick}
          className="inline-flex cursor-pointer items-center gap-[7px] rounded-[7px] bg-indigo-600 px-[18px] py-[9px] text-[13px] font-medium text-white transition-colors hover:bg-indigo-700"
        >
          <PlusIcon />
          Add a form
        </button>
      )}
    </div>
  );
};
